// PDF Styles Constants
import { greyP4 } from '../../../../theme.ts';

export const PDF_STYLES_CONSTANTS = {
  // Page dimensions (A4: 595pt width)
  DIMENSIONS: {
    FULL_WIDTH: 595,
    LEFT_MARGIN: 74,
    RIGHT_MARGIN: 34,
    CONTENT_WIDTH: 487, // 595 - 74 - 34
    CONTENT_WIDTH_NARROW: 400, // TableOfContent uses narrower width
    LOGO_WIDTH: 90,
    SECTION_WIDTH: 30,
  },

  // Positioning
  POSITIONS: {
    HEADER_TOP: 35,
    FOOTER_BOTTOM: 35,
  },

  // Spacing and padding
  SPACING: {
    PADDING_TOP_SMALL: 10,
    PADDING_TOP_MEDIUM: 20,
    PADDING_TOP_LARGE: 30,
    PADDING_BOTTOM_SMALL: 4,
    PADDING_BOTTOM_MEDIUM: 20,
    MARGIN_TOP_SMALL: 20,
    MARGIN_TOP_LARGE: 200,
    MARGIN_TOP_MEDIUM: 30,
    MARGIN_LEFT: 30,
    GAP: 20,
  },

  // Font sizes
  FONT_SIZES: {
    TINY: 6,
    SMALL: 8,
    SMALL_MEDIUM: 9,
    MEDIUM: 10,
    LARGE: 12,
    MEDIUM_LARGE: 13,
    X_LARGE: 16,
    XX_LARGE: 18,
  },

  // Font weights
  FONT_WEIGHTS: {
    NORMAL: 500,
    BOLD: 700,
  },

  // Colors
  COLORS: {
    PRIMARY_DARK: greyP4,
    SECONDARY_DARK: '#3E3E3E',
    LIGHT_GRAY: '#ccc',
    BLACK: '#000',
  },

  // Border styles
  BORDERS: {
    THIN_GRAY: '0.25 solid #ccc',
    THICK_BLACK: '1 solid #000',
  },

  // Layout values
  LAYOUT: {
    FLEX_FULL: 1,
    BORDER_WIDTH_THIN: 0.25,
    BORDER_WIDTH_THICK: 1,
  },
} as const;
